import request from '@/utils/request'

let ImportApi = {

    /* 上传商品导入文件  */
    get_upload(formData, errorback) {
        return request._upload('/shop/product.product/excel_upload', formData, errorback);
    },

    /* 获取后台域名 */
    uploadUrl(data, errorback) {
        return request._get('/shop/plus.customer.customer/upload_url', data, errorback);
    },
}

export default ImportApi;



// WEBPACK FOOTER //
// ./src/api/import.js